var React = require('react');

function DownArrow (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#979797","fillRule":"nonzero"},[React.createElement("path",{"d":"M8 0v149H7V0z","key":0}),React.createElement("path",{"d":"M14.396 142l.708.707-7.552 7.552L0 142.707.707 142l6.845 6.845z","key":1})]));
}

DownArrow.defaultProps = {"width":"16","height":"151","viewBox":"0 0 16 151"};

module.exports = DownArrow;

DownArrow.default = DownArrow;
